import React from 'react'
import { useTranslate } from 'react-admin'
import { EventBrief } from 'services/api/entities/eventBrief'
import { MappedEnrichedEvent } from 'services/api/entities/events/types/internal/event-models'
import { serviceDiscriminatorArray } from 'services/cfg/form'
import { pdfCss } from 'services/pdf-print/pdf-css'
import { getDateAsString, getTimeLabelFromDate } from 'services/utils/date'

type Props = {
  surveyResponses: EventBrief
  eventInfo: MappedEnrichedEvent
}

const BriefPdfRenderer: React.FC<Props> = ({ surveyResponses, eventInfo }) => {
  const translate = useTranslate()
  return (
    <html>
      <head>
        <title>Event Brief {eventInfo.name}</title>
        <style>{pdfCss}</style>
      </head>
      <body>
        <section>
          <div className="page-header"></div>

          <div className="page-footer">
            <div className="footer-text f-size-12">
              Kampaay SRL – Startup Innovativa, Via Malaga,4, 20143, Milano,
              Italia | P.Iva 11046500960
            </div>
            <div className="f-size-12">
              <a href="mailto:info@kampaay.com">info@kampaay.com</a>|
              <a
                rel="noreferrer"
                href="https://www.kampaay.com/"
                target="_blank"
              >
                www.kampaay.com
              </a>
            </div>
          </div>

          <table className="quotation-body">
            <thead>
              <tr>
                <td>
                  <div className="header-space ">
                    {/* <img
                      src="assets/logo-orange-wide.png"
                      alt="logo-kampaay"
                      className="header-logo text-center"
                    /> */}
                  </div>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <div className="page-content">
                    <section>
                      <p className="text-right">
                        {getDateAsString(new Date().toISOString())}
                      </p>
                      <h4>Azienda</h4>
                      <p>{eventInfo.customerInfo.name}</p>
                      <h4>Numero di telefono referente</h4>
                      <p>{eventInfo.customerInfo.phone}</p>
                      <h4>Evento</h4>
                      <p>
                        {eventInfo.name} -{' '}
                        {getDateAsString(eventInfo.startDate)}
                      </p>
                      <h4>Data e ora</h4>
                      <p>
                        {getDateAsString(eventInfo.startDate)} -{' '}
                        {getTimeLabelFromDate(eventInfo.startDate)}
                      </p>
                      <h4>Numero Ospiti</h4>
                      <p>{eventInfo.guestsNumber}</p>
                      <h4>Indirizzo</h4>
                      <p>{eventInfo.fullAddress}</p>
                    </section>
                    <section>
                      <h2 className="text-center mt-15 mb-15">Brief</h2>
                      <hr />
                      <div>
                        {surveyResponses.map(
                          ({ questionResponses, supplieredService }, idx) => (
                            <section key={`question_service_${idx}`}>
                              <h2 className="underlined text-capitalize">
                                {(
                                  serviceDiscriminatorArray as string[]
                                ).includes(supplieredService)
                                  ? translate(
                                      `form.headers.${supplieredService}`
                                    )
                                  : supplieredService}
                              </h2>

                              <div>
                                {questionResponses?.map((qr, idx) => (
                                  <React.Fragment key={idx}>
                                    <h3 className="mt-15">{qr.question}</h3>
                                    <p className="mb-15">{qr.response}</p>
                                  </React.Fragment>
                                ))}
                              </div>
                              <hr className="mt-15" />
                            </section>
                          )
                        )}
                      </div>
                    </section>
                  </div>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td>
                  <div className="footer-space">&nbsp;</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </section>
      </body>
    </html>
  )
}

export default BriefPdfRenderer
